const check = {

	init: function() {

		/**
		 * Listen to keydown event
		 *
		 * @type {HTMLElement} - the target of the event
		 * @listens document#keydown - the namespace and name of the event
		 */
		document.querySelectorAll('.input-mfa').forEach(function(inputElement) {
			inputElement.addEventListener('keydown', function(e) {
				check.nextOrPrevInput(e);
			});
		});

		/**
		 * Listen to keyup event
		 *
		 * @type {HTMLElement} - the target of the event
		 * @listens document#keyup - the namespace and name of the event
		 */
		document.querySelectorAll('.input-mfa').forEach(function(inputElement) {
			inputElement.addEventListener('keyup', function() {
				check.submitForm();
			});
		});

		/**
		 * Listen to paste event
		 *
		 * @type {HTMLElement} - the target of the event
		 * @listens document#paste - the namespace and name of the event
		 */
		document.querySelectorAll('.input-mfa').forEach(function(inputElement) {
			inputElement.addEventListener('paste', function(e) {
				check.pasteHandler(e);
				check.submitForm();
			});
		});

		/**
		 * Listen to paste event
		 *
		 * @type {HTMLElement} - the target of the event
		 * @listens document#paste - the namespace and name of the event
		 */
		document.querySelector('#MFA_code').addEventListener('paste', function(e) {
			var pastedData = check.getClipboardData(e);
			document.querySelector('#MFA_code').value = pastedData;
		});

	},


	/**
	 * nextOrPrevInput
	 * @param {event} e
	 */
	nextOrPrevInput: function(e) {
		var el = e.target;
		if (e.keyCode === 8) {
			el.value = '';
			var prevElement = el.previousElementSibling;
			if (prevElement) {
				prevElement.value = '';
				prevElement.focus();
			}
		} else if (e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== 16) {
			var val = el.value;
			if (val !== '') {
				var nextElement = el.nextElementSibling;
				if (nextElement) {
					nextElement.focus();
				}
			}
		}
	},

	/**
	 * getClipboardData
	 * @param {event} e
	 * @returns {string} pastedData
	 */
	getClipboardData: function(e) {
		var clipboardData = e.clipboardData || window.clipboardData || e.originalEvent.clipboardData;
		return clipboardData.getData('Text').replace(/[^0-9]/g, '');
	},

	/**
	 * pasteHandler
	 * @param {event} e
	 */
	pasteHandler: function(e) {
		var pastedData = check.getClipboardData(e);
		var codeArray = pastedData.split('');
		var mfaFields = document.querySelectorAll('.form-group-mfa input');
		codeArray.forEach(function(v, i) {
			mfaFields[i].value = v;
		});
	},

	/**
	 * mergeMfaInputValues
	 * @returns {string} MfaValue
	 */
	mergeMfaInputValues: function() {
		var value = '';
		var inputs = document.querySelectorAll('.form-group-mfa input');
		inputs.forEach(function(input) {
			value += input.value;
		});
		return value;
	},

	/**
	 * submitform
	 * @returns {string} MfaValue
	 */
	submitForm: function() {
		var fields = document.querySelectorAll('.form-group-mfa input');
		var code = check.mergeMfaInputValues();
		document.querySelector('#MFA_code').value = code;
		if (code.length == 6) {
			fields.forEach(function(field) {
				field.blur();
				field.setAttribute('readonly', true);
			});
			document.querySelector('#mfaForm').submit();
		}
	}

};

export default check;
